import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Changepassword.scss";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import Swal from "sweetalert2";
import { changePassword } from "../services/api";

function ChangePassword() {
  const navigate = useNavigate();
  const [userObj, setUserObj] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const submit = async () => {
    let formData = { ...userObj };

    if (!formData.old_password) {
      Swal.fire({
        text: "Please enter old password.",
        showConfirmButton: false,
        icon: "warning",
        timer: 3000,
      });
      return;
    } else if (!userObj.new_password) {
      Swal.fire({
        text: "Please enter new password.",
        showConfirmButton: false,
        icon: "warning",
        timer: 3000,
      });
      return;
    } else if (
      userObj.new_password.length < 8 ||
      userObj.new_password.length > 16
    ) {
      Swal.fire({
        text: "New password must be between 8 and 16 characters.",
        showConfirmButton: false,
        icon: "warning",
        timer: 3000,
      });
      return;
    } else if (userObj.old_password === userObj.new_password) {
      Swal.fire({
        text: "New password should not match with old password!",
        showConfirmButton: false,
        icon: "warning",
        timer: 3000,
      });
      return;
    } else if (!userObj.confirm_password) {
      Swal.fire({
        text: "Please enter confirm password.",
        showConfirmButton: false,
        icon: "warning",
        timer: 3000,
      });
      return;
    } else if (userObj.confirm_password !== userObj.new_password) {
      Swal.fire({
        text: "New password should match with confirm password!",
        showConfirmButton: false,
        icon: "warning",
        timer: 3000,
      });
      return;
    } else {
      Swal.fire({
        html: `<img src=${require("../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });

      // Get user_id from localStorage
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      const user_id = userData?.user?.id;

      if (!user_id) {
        Swal.close();
        Swal.fire({
          text: "User information not found. Please login again.",
          showConfirmButton: false,
          icon: "warning",
          timer: 3000,
        }).then(() => {
          localStorage.clear();
          navigate("/login");
        });
        return;
      }

      // const correl_id = localStorage.getItem("correl_id");
      let resData = await changePassword({
        ...formData,
        user_id,
        // correl_id
      });
      Swal.close();

      if (resData.status === "S") {
        Swal.fire({
          text: "Password changed, Redirecting to Login!",
          showConfirmButton: false,
          icon: "success",
          timer: 3000,
        }).then(() => {
          navigate("/login");
        });
      } else if (resData.status === "E" && resData.result_code === 404) {
        Swal.fire({
          text: "Account not found.",
          showConfirmButton: false,
          icon: "warning",
          timer: 3000,
        }).then(() => {
          localStorage.clear();
          navigate("/login");
        });
        return;
      } else if (resData.status === "E" && resData.result_code === 401) {
        Swal.fire({
          text: "Invalid old password.",
          showConfirmButton: false,
          icon: "warning",
          timer: 3000,
        });
        return;
      } else if (resData.status === "E" && resData.result_code === 400) {
        Swal.fire({
          text:
            resData.error_info ||
            "New password and confirm password does not match.",
          showConfirmButton: false,
          icon: "warning",
          timer: 3000,
        });
        return;
      } else if (
        resData.status === "F" &&
        resData.message === "Unauthorized - Missing token"
      ) {
        Swal.fire({
          text: "Please login with your credentials",
          icon: "warning",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          localStorage.clear();
          navigate("/login");
        });
      } else if (
        resData.status === "F" &&
        resData.message === "Unauthorized - Invalid token"
      ) {
        Swal.fire({
          text: "Please login with your credentials",
          icon: "warning",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          localStorage.clear();
          navigate("/login");
        });
      } else {
        Swal.fire({
          text: resData.error_info || JSON.stringify(resData),
          showConfirmButton: false,
          icon: "warning",
          timer: 3000,
        });
        return;
      }
    }
  };

  return (
    <div className="loginContainer pwd-screen">
      <div className="row g-0 h-100 w-100">
        <div className="col-6 d-none d-lg-block">
          <div className="loginLeft d-none d-lg-flex">
            <h5 className="headingText">
              <strong>Welcome to UpwardIQ Suite</strong>
            </h5>
            <img
              src={require("../assets/image.jpg")}
              alt="RECUPE"
              className="vec-image"
            />
            <p>
              A streamlined applicant tracking system to manage job
              requisitions, track candidate progress, and monitor recruitment
              activity — all in one place.
            </p>
          </div>
        </div>
        <div className="col-12 col-lg-6 h-100">
          <div className="loginRight h-100">
            <h5 className="loginText text-white">Change Password</h5>
            <TextField
              id="outlined-basic"
              label="Old Password"
              variant="outlined"
              type={showPassword ? "text" : "password"}
              className="mb-4 cust-white-input-field w-100"
              autoComplete="off"
              value={userObj.old_password}
              onChange={(ev) => {
                const input = ev.target.value;
                setUserObj({
                  ...userObj,
                  old_password: input,
                });
              }}
              inputProps={{
                minLength: 8,
                maxLength: 16,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="text-white"
                      aria-label="toggle password visibility"
                      onClick={() => {
                        setShowPassword(!showPassword);
                      }}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              id="outlined-basic"
              label="New Password"
              variant="outlined"
              type={showPassword1 ? "text" : "password"}
              className="mb-4 cust-white-input-field w-100"
              autoComplete="off"
              value={userObj.new_password}
              onChange={(ev) => {
                const input = ev.target.value;
                setUserObj({
                  ...userObj,
                  new_password: input,
                });
              }}
              inputProps={{
                minLength: 8,
                maxLength: 16,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="text-white"
                      aria-label="toggle password visibility"
                      onClick={() => {
                        setShowPassword1(!showPassword1);
                      }}
                      edge="end"
                    >
                      {showPassword1 ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              id="outlined-basic"
              label="Confirm Password"
              variant="outlined"
              type={showPassword2 ? "text" : "password"}
              className="mb-4 cust-white-input-field w-100"
              autoComplete="off"
              value={userObj.confirm_password}
              onChange={(ev) => {
                const input = ev.target.value;
                setUserObj({
                  ...userObj,
                  confirm_password: input,
                });
              }}
              inputProps={{
                minLength: 8,
                maxLength: 16,
              }}
              onKeyDown={(ev) => {
                if (ev.key === "Enter") {
                  ev.preventDefault();
                  submit();
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="text-white"
                      aria-label="toggle password visibility"
                      onClick={() => {
                        setShowPassword2(!showPassword2);
                      }}
                      edge="end"
                    >
                      {showPassword2 ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <div>
              <button
                className="btn btn-white rounded-pill text-uppercase"
                onClick={() => {
                  submit();
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
